// removed by extract-text-webpack-plugin
module.exports = {"osInputContainer":"_193Wu8kMoxqDvii-gVi8HH","osInputText":"_2t_XYZ2MTkV6VrvN1Ixgjr","osInputTextW":"_1I-lAdWWF3WOhpq6W7TnNo"};


//////////////////
// WEBPACK FOOTER
// ./src/App/components/fields/PhoneNumber/styles.css
// module id = 2948
// module chunks = 0